module.exports = __webpack_public_path__ + "img/forget_pw.79828a36.svg";